export default {
    adaHomeBackground: "black",
    adaHomeDividerShadow: "none",
    adaHomeDividerBackground: "none",
    cardBorder: "2px solid white",
    cardBackground: "none",
    cardBoxShadow: "none",
    cardBoxShadowHover: "7px 7px 7px orange,-7px -7px 7px orange",
};
